// pages/Create.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import Layout from '~/components/Layout';
import IEquipmentGroup from '../interfaces/IEquipmentGroup';

export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue } = useForm<IEquipmentGroup>();
  const fields = [
    { name: 'name', type: 'string' },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model={'equipment-group'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Equipment group successfully created!'}
        title={'Add equipment group'}
        subheader={'Add equipment group'}
        setFormValue={setFormValue}
      />
    </Layout>
  );
}